import { Typography } from "@material-ui/core";
import React from "react";
import { useForm, Controller } from "react-hook-form";

import { makeStyles } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import apiHelper from "../../util/ApiHelper";
import { Roles } from "../../util/PermissionProvider";

const useStyles = makeStyles((theme) => ({
  body: {
    width: "100%",
    height: "100vh",
    backgroundColor: "#E5E5E5",
  },
  content: {
    width: "400px",
    margin: "0 auto",
    paddingTop: "15%",
  },
  h4: {
    marginBottom: "10px",
    color: "#333333",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "370px",
    padding: "25px 15px",
    border: "1px solid",
    borderRadius: "3px",
    backgroundColor: "white",

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "340px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
      alignSelf: "flex-end",
    },
  },
  a: {
    textDecoration: "none",
    color: "#333333",

    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const LoginPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const { control, handleSubmit, setError } = useForm();

  const onSubmit = async (data) => {
    console.log(data);
    try {
      const result = await apiHelper.adminLogin(data);
      if (result.data.roles) {
        redirectUser(result.data.roles);
      } else {
        switch (result.data.code) {
          case -10:
            setError("login", {
              type: "invalid",
              message: "Incorrect username or password",
            });
            setError("password", {
              type: "invalid",
              message: "Incorrect username or password",
            });
            break;
          default:
            break;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    if (
      sessionStorage.getItem("adminInfo") &&
      sessionStorage.getItem("adminInfo") !== "undefined"
    ) {
      redirectUser(JSON.parse(sessionStorage.getItem("adminInfo"))?.roles);
    }
  }, []);

  const redirectUser = (roles) => {
    if (roles[0]?.id === Roles.HKIFF_MA_EDITOR) {
      history.push("/hkiff/media-accreditation");
    } else {
      history.push("/cinefan/movies");
    }
  };

  return (
    <div className={classes.body}>
      <div className={classes.content}>
        <Typography variant="h4" className={classes.h4}>
          HKIFF Master CMS Login
        </Typography>
        <form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="login"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label="Username"
                variant="outlined"
                margin="dense"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
            rules={{ required: "Username required" }}
          />

          <Controller
            name="password"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label="Password"
                variant="outlined"
                margin="dense"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
                type="password"
              />
            )}
            rules={{ required: "Password required" }}
          />
          <Button type="submit" variant="contained" color="primary">
            Login
          </Button>
        </form>
        <Link to="" className={classes.a}>
          Forget Password ?
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
